export const estadoCivilList = [
  {id: "C", descricao: "Casado"},
  {id: "D", descricao: "Separado"},
  {id: "I", descricao: "Divorciado"},
  {id: "M", descricao: "Marital "},
  {id: "S", descricao: "Solteiro"},
  {id: "V", descricao: "Viúvo"},
]

export const grauInstrucaoList = [
  {id: 1, descricao: "ANALFABETO"},
  {id: 2, descricao: "ATÉ 4ª SÉRIE INCOMPLETA DO ENSINO FUNDAMENTAL"},
  {id: 3, descricao: "4ª SÉRIE COMPLETA DO ENSINO FUNDAMENTAL"},
  {id: 4, descricao: "DA 5ª A 8ª SÉRIE DO ENSINO FUNDAMENTAL"},
  {id: 5, descricao: "ENSINO FUNDAMENTAL COMPLETO"},
  {id: 6, descricao: "ENSINO MÉDIO INCOMPLETO"},
  {id: 7, descricao: "ENSINO MÉDIO COMPLETO"},
  {id: 8, descricao: "EDUCAÇÃO SUPERIOR INCOMPLETO"},
  {id: 9, descricao: "EDUCAÇÃO SUPERIOR COMPLETO"},
  {id: 10, descricao: "PÓS-GRADUAÇÃO INCOMPLETO"},
  {id: 11, descricao: "PÓS-GRADUAÇÃO COMPLETO"},
  {id: 12, descricao: "MESTRADO INCOMPLETO"},
  {id: 13, descricao: "MESTRADO COMPLETO"},
  {id: 14, descricao: "DOUTORADO INCOMPLETO"},
  {id: 15, descricao: "DOUTORADO COMPLETO"},
  {id: 16, descricao: "PÓS-DOUTORADO INCOMPLETO"},
  {id: 17, descricao: "PÓS-DOUTORADO COMPLETO"},
]

export const orgaoEmissorList = [
  "AERONAUTICA", "CBMERJ", "CBMG", "CBMPA", "CFP", "COREN", "CRC", "CRE", "CREA", "CRESS", "DETRAN", "DGPC",
  "DPF", "DRT", "EXERCITO", "IFP", "IMLEC", "IPF", "MARINHA", "MT", "OAB", "PM", "PMERJ", "PMMG", "PMPA",
  "POLICIA CIVIL", "POLICIA FEDERAL", "SDS", "SJS", "SJT", "SPTC", "SSP",
]

export const codigoSituacaoServidorList = [
  {id: 1, descricao: "Ativo Permanente"},
  {id: 2, descricao: "Aposentado"},
  {id: 3, descricao: "Requisitado"},
  {id: 4, descricao: "Nomeado Cargo Comissionado"},
  {id: 7, descricao: "Natureza Especial"},
  {id: 8, descricao: "Cedido"},
  {id: 9, descricao: "Redistribuído"},
  {id: 10, descricao: "Ativo Transitorio"},
  {id: 11, descricao: "Excedente a Lotação"},
  {id: 17, descricao: "Aposentado TCU"},
  {id: 21, descricao: "Ativo Perm L.8878/94"},
  {id: 22, descricao: "Anistiado ADCT CF"},
  {id: 33, descricao: "Reforma CBM/PM"},
  {id: 38, descricao: "Ativi - DEC JUDIC"},
  {id: 39, descricao: "Aposentado - DEC JUDIC"},
  {id: 54, descricao: "Cont.Prof.Temporário"},
  {id: 93, descricao: "Pensão Vitalicia/Temporário"},
  {id: 94, descricao: "BENEF.PENS.ANS46 "},
]

export const bankList = [
  {id: "280", descricao: "Avista S.A."},
  {id: "654", descricao: "Banco A.J.Renner S.A."},
  {id: "246", descricao: "Banco ABC Brasil S.A."},
  {id: "121", descricao: "Banco Agibank S.A."},
  {id: "25", descricao: "Banco Alfa S.A."},
  {id: "213", descricao: "Banco Arbi S.A."},
  {id: "19", descricao: "Banco Azteca do Brasil S.A."},
  {id: "29", descricao: "Banco Banerj S.A."},
  {id: "740", descricao: "Banco Barclays S.A."},
  {id: "107", descricao: "Banco BBM S.A."},
  {id: "739", descricao: "Banco BGN S.A."},
  {id: "96", descricao: "Banco BM&F de Serviços de Liquidação e Custódia S.A"},
  {id: "318", descricao: "Banco BMG S.A."},
  {id: "752", descricao: "Banco BNP Paribas Brasil S.A."},
  {id: "248", descricao: "Banco Boavista Interatlântico S.A."},
  {id: "65", descricao: "Banco Bracce S.A."},
  {id: "237", descricao: "Banco Bradesco S.A."},
  {id: "225", descricao: "Banco Brascan S.A."},
  {id: "218", descricao: "Banco Bs2 S.A."},
  {id: "208", descricao: "Banco BTG Pactual S.A."},
  {id: "44", descricao: "Banco BVA S.A."},
  {id: "336", descricao: "Banco C6 S.A (C6 Bank)"},
  {id: "263", descricao: "Banco Cacique S.A."},
  {id: "412", descricao: "Banco Capital S.A."},
  {id: "40", descricao: "Banco Cargill S.A."},
  {id: "266", descricao: "Banco Cédula S.A."},
  {id: "745", descricao: "Banco Citibank S.A."},
  {id: "241", descricao: "Banco Clássico S.A."},
  {id: "215", descricao: "Banco Comercial e de Investimento Sudameris S.A."},
  {id: "756", descricao: "Banco Cooperativo do Brasil S.A. – BANCOOB"},
  {id: "748", descricao: "Banco Cooperativo Sicredi S.A."},
  {id: "75", descricao: "Banco CR2 S.A. "},
  {id: "222", descricao: "Banco Credit Agricole Brasil S.A."},
  {id: "505", descricao: "Banco Credit Suisse (Brasil) S.A."},
  {id: "3", descricao: "Banco da Amazônia S.A."},
  {id: "83", descricao: "Banco da China Brasil S.A."},
  {id: "707", descricao: "Banco Daycoval S.A."},
  {id: "300", descricao: "Banco de La Nacion Argentina"},
  {id: "495", descricao: "Banco de La Provincia de Buenos Aires"},
  {id: "494", descricao: "Banco de La Republica Oriental del Uruguay"},
  {id: "456", descricao: "Banco de Tokyo-Mitsubishi UFJ Brasil S.A."},
  {id: "214", descricao: "Banco Dibens S.A."},
  {id: "1", descricao: "Banco do Brasil S.A."},
  {id: "47", descricao: "Banco do Estado de Sergipe S.A."},
  {id: "37", descricao: "Banco do Estado do Pará S.A."},
  {id: "41", descricao: "Banco do Estado do Rio Grande do Sul S.A."},
  {id: "4", descricao: "Banco do Nordeste do Brasil S.A."},
  {id: "265", descricao: "Banco Fator S.A."},
  {id: "224", descricao: "Banco Fibra S.A."},
  {id: "626", descricao: "Banco Ficsa S.A."},
  {id: "94", descricao: "Banco Finaxis"},
  {id: "233", descricao: "Banco GE Capital S.A."},
  {id: "612", descricao: "Banco Guanabara S.A."},
  {id: "63", descricao: "Banco Ibi S.A. Banco Múltiplo"},
  {id: "604", descricao: "Banco Industrial do Brasil S.A."},
  {id: "320", descricao: "Banco Industrial e Comercial S.A."},
  {id: "653", descricao: "Banco Indusval S.A."},
  {id: "630", descricao: "Banco Intercap S.A."},
  {id: "77", descricao: "Banco Inter S.A."},
  {id: "249", descricao: "Banco Investcred Unibanco S.A."},
  {id: "376", descricao: "Banco J. P. Morgan S.A."},
  {id: "74", descricao: "Banco J. Safra S.A."},
  {id: "217", descricao: "Banco John Deere S.A."},
  {id: "76", descricao: "Banco KDB S.A."},
  {id: "757", descricao: "Banco KEB do Brasil S.A."},
  {id: "600", descricao: "Banco Luso Brasileiro S.A."},
  {id: "212", descricao: "Banco Matone S.A."},
  {id: "243", descricao: "Banco Máxima S.A."},
  {id: "389", descricao: "Banco Mercantil do Brasil S.A."},
  {id: "746", descricao: "Banco Modal S.A."},
  {id: "66", descricao: "Banco Morgan Stanley S.A."},
  {id: "45", descricao: "Banco Opportunity S.A."},
  {id: "79", descricao: "Banco Original do Agronegócio S.A."},
  {id: "623", descricao: "Banco Panamericano S.A."},
  {id: "611", descricao: "Banco Paulista S.A."},
  {id: "613", descricao: "Banco Pecúnia S.A."},
  {id: "643", descricao: "Banco Pine S.A."},
  {id: "735", descricao: "Banco Pottencial S.A."},
  {id: "747", descricao: "Banco Rabobank International Brasil S.A."},
  {id: "88", descricao: "Banco Randon S.A."},
  {id: "356", descricao: "Banco Real S.A."},
  {id: "633", descricao: "Banco Rendimento S.A."},
  {id: "741", descricao: "Banco Ribeirão Preto S.A."},
  {id: "120", descricao: "Banco Rodobens S.A."},
  {id: "72", descricao: "Banco Rural Mais S.A."},
  {id: "453", descricao: "Banco Rural S.A."},
  {id: "422", descricao: "Banco Safra S.A."},
  {id: "33", descricao: "Banco Santander (Brasil) S.A."},
  {id: "250", descricao: "Banco Schahin S.A."},
  {id: "81", descricao: "Banco Seguro S.A."},
  {id: "743", descricao: "Banco Semear S.A."},
  {id: "749", descricao: "Banco Simples S.A."},
  {id: "366", descricao: "Banco Société Générale Brasil S.A."},
  {id: "637", descricao: "Banco Sofisa S.A."},
  {id: "464", descricao: "Banco Sumitomo Mitsui Brasileiro S.A."},
  {id: "82", descricao: "Banco Topázio S.A."},
  {id: "634", descricao: "Banco Triângulo S.A."},
  {id: "655", descricao: "Banco Votorantim S.A."},
  {id: "610", descricao: "Banco VR S.A."},
  {id: "119", descricao: "Banco Western Union do Brasil S.A."},
  {id: "370", descricao: "Banco WestLB do Brasil S.A."},
  {id: "124", descricao: "Banco Woori Bank Do Brasil S.A."},
  {id: "21", descricao: "BANESTES S.A. (Banco do Estado do Espírito Santo)"},
  {id: "719", descricao: "Banif-Banco Internacional do Funchal (Brasil)S.A."},
  {id: "755", descricao: "Bank of America Merrill Lynch Banco Múltiplo S.A."},
  {id: "78", descricao: "BES Investimento do Brasil S.A. (Banco de Investimento)"},
  {id: "69", descricao: "BPN Brasil Banco Múltiplo S.A."},
  {id: "70", descricao: "BRB (Banco de Brasília S.A.)"},
  {id: "92", descricao: "Brickell S.A. Crédito, financiamento e Investimento"},
  {id: "104", descricao: "Caixa Econômica Federal"},
  {id: "273", descricao: "Ccr De São Miguel Do Oeste"},
  {id: "114", descricao: "Central Cooperativa de Crédito no Estado do Espírito Santo"},
  {id: "477", descricao: "Citibank N.A."},
  {id: "97", descricao: "Cooperativa Central de Crédito Noroeste Brasileiro Ltda."},
  {id: "85", descricao: "Cooperativa Central de Crédito Urbano (CECRED)"},
  {id: "89", descricao: "Cooperativa de Crédito Rural da Região de Mogiana"},
  {id: "322", descricao: "Cooperativa de Crédito Rural de Abelardo Luz (Sulcredi/Crediluz)"},
  {id: "87", descricao: "Cooperativa Unicred Central Santa Catarina"},
  {id: "403", descricao: "CORA Sociedade de Crédito Direto S.A."},
  {id: "98", descricao: "Credialiança Ccr"},
  {id: "10", descricao: "CREDICOAMO (Crédito Rural Cooperativa)"},
  {id: "133", descricao: "Cresol Confederação"},
  {id: "487", descricao: "Deutsche Bank S.A. (Banco Alemão)"},
  {id: "751", descricao: "Dresdner Bank Brasil S.A. (Banco Múltiplo)"},
  {id: "62", descricao: "Hipercard Banco Múltiplo S.A."},
  {id: "399", descricao: "HSBC Bank Brasil S.A. (Banco Múltiplo)"},
  {id: "492", descricao: "ING Bank N.V."},
  {id: "341", descricao: "Itaú Unibanco S.A."},
  {id: "488", descricao: "JPMorgan Chase Bank"},
  {id: "105", descricao: "Lecca Cfi S.A."},
  {id: "323", descricao: "Mercado Pago (Conta do Mercado Livre)"},
  {id: "14", descricao: "Natixis Brasil S.A. Banco Múltiplo"},
  {id: "753", descricao: "NBC Bank Brasil S.A. (Banco Múltiplo)"},
  {id: "260", descricao: "Nu Pagamentos S.A (Nubank)"},
  {id: "290", descricao: "PagSeguro Internet S.A."},
  {id: "254", descricao: "Paraná Banco S.A."},
  {id: "380", descricao: "PICPAY Serviços S.A."},
  {id: "197", descricao: "Stone Pagamentos S.A."},
  {id: "409", descricao: "Unibanco (União de Bancos Brasileiros S.A.)"},
  {id: "230", descricao: "Unicard Banco Múltiplo S.A."},
  {id: "91", descricao: "Unicred Central do Rio Grande do Sul"},
  {id: "136", descricao: "Unicred Cooperativa LTDA"},
  {id: "84", descricao: "Unicred Norte do Paraná"},
  {id: "99", descricao: "Uniprime Central Ccc Ltda"},
  {id: "102", descricao: "XP Investimentos S.A."},
  {id: "536", descricao: "Neon"},
]

export const ufList = [
  {sigla: "AC", estado: "Acre	Rio Branco"},
  {sigla: "AL", estado: "Alagoas"},
  {sigla: "AP", estado: "Amapá"},
  {sigla: "AM", estado: "Amazonas"},
  {sigla: "BA", estado: "Bahia"},
  {sigla: "CE", estado: "Ceara"},
  {sigla: "DF", estado: "Distrito Federal"},
  {sigla: "ES", estado: "Espírito Santo"},
  {sigla: "GO", estado: "Goiás"},
  {sigla: "MA", estado: "Maranhão"},
  {sigla: "MT", estado: "Mato Grosso"},
  {sigla: "MS", estado: "Mato Grosso do Sul"},
  {sigla: "MG", estado: "Minas Gerais"},
  {sigla: "PA", estado: "Pará"},
  {sigla: "PB", estado: "Paraíba"},
  {sigla: "PR", estado: "Paraná"},
  {sigla: "PE", estado: "Pernambuco"},
  {sigla: "PI", estado: "Piauí"},
  {sigla: "RJ", estado: "Rio de Janeiro"},
  {sigla: "RN", estado: "Rio Grande do Norte"},
  {sigla: "RS", estado: "Rio Grande do Sul"},
  {sigla: "RO", estado: "Rondônia"},
  {sigla: "RR", estado: "Roraima"},
  {sigla: "SC", estado: "Santa Catarina"},
  {sigla: "SP", estado: "São Paulo"},
  {sigla: "SE", estado: "Sergipe"},
  {sigla: "TO", estado: "Tocantins"},
]